var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 1.5L6 2.25V4.5405C6.49851 4.48599 7.00149 4.48599 7.5 4.5405V3H21V10.5H18.4395L16.5 12.4395V10.5H13.4595C13.514 10.9985 13.514 11.5015 13.4595 12H15V14.25L16.281 14.781L19.0605 12H21.75L22.5 11.25V2.25L21.75 1.5H6.75Z",
    fill: "#5B595C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6255 15.6435C10.5714 15.0243 11.2921 14.1163 11.6805 13.0545C12.0689 11.9928 12.1041 10.834 11.7811 9.75066C11.458 8.66727 10.7938 7.71711 9.88734 7.04151C8.98087 6.36592 7.88054 6.00098 6.75 6.00098C5.61946 6.00098 4.51913 6.36592 3.61266 7.04151C2.70619 7.71711 2.04202 8.66727 1.71894 9.75066C1.39586 10.834 1.43113 11.9928 1.81951 13.0545C2.20789 14.1163 2.92862 15.0243 3.8745 15.6435C2.71596 16.189 1.7365 17.0528 1.05045 18.1341C0.364399 19.2153 7.23459e-05 20.4694 0 21.75L0 22.5H1.5V21.75C1.54604 20.3883 2.11933 19.0978 3.09887 18.1508C4.0784 17.2038 5.38755 16.6745 6.75 16.6745C8.11245 16.6745 9.4216 17.2038 10.4011 18.1508C11.3807 19.0978 11.954 20.3883 12 21.75V22.5H13.5V21.75C13.4999 20.4694 13.1356 19.2153 12.4496 18.1341C11.7635 17.0528 10.784 16.189 9.6255 15.6435ZM6.75 15C5.75544 15 4.80161 14.6049 4.09835 13.9016C3.39509 13.1984 3 12.2445 3 11.25C3 10.2554 3.39509 9.30158 4.09835 8.59832C4.80161 7.89506 5.75544 7.49997 6.75 7.49997C7.74456 7.49997 8.69839 7.89506 9.40165 8.59832C10.1049 9.30158 10.5 10.2554 10.5 11.25C10.5 12.2445 10.1049 13.1984 9.40165 13.9016C8.69839 14.6049 7.74456 15 6.75 15Z",
    fill: "#5B595C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_1111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.6e437327d74f206f552d8bcf56781aee.svg";
export { ForwardRef as ReactComponent };